import { DOMHelper } from 'core/DOMHelper';
import { UIThemeColourType } from 'app/data/Enums';
import { SidePaging } from 'app/module/project/SidePaging';
import { HeaderType } from './project.types';

/**
 * DOM side of the project section: element refs, the injected DOM structure
 * template and the SidePaging module interop. HTML injection itself and the
 * SidePaging event wiring stay in ProjectController (module lifecycle +
 * Events.on registrations live there).
 */
export class ProjectView {
	private _dom: DOMHelper;

	public $content: HTMLElement;
	public $close: HTMLElement;
	public $home: HTMLElement;
	public $dynamicContent: HTMLElement;
	public $loading: HTMLElement;
	public $backToProjectImages: HTMLElement;
	public $backToProjectTrigger: HTMLElement;
	public $projectCTA: HTMLElement;

	private _sidePaging: SidePaging;

	constructor(dom: DOMHelper) {
		this._dom = dom;
	}

	//Element refs
	//-------------------------------------------------------------------------------------

	/** Query the non-media element refs (media refs live in ProjectMedia) */
	public queryRefs(container: Element): void {
		//Header buttons
		this.$close = document.querySelector('.ui_close.project__close');
		this.$home = container.querySelector('.project__home');

		//Content / scroll area
		this.$content = container.querySelector('.project__content');
		this.$dynamicContent = this.$content.querySelector('.project__dynamic__content');

		this.$backToProjectImages = container.querySelector('.back-to-project');
		this.$backToProjectTrigger = container.querySelector('.back-to-project-trigger');

		//Loading panel
		this.$loading = container.querySelector('.project__loading');

		//Parallax project CTA
		this.$projectCTA = container.querySelector('.project__cta');
	}

	//Side paging
	//-------------------------------------------------------------------------------------

	public createSidePaging(container: Element): void {
		this._sidePaging = new SidePaging(container.querySelector('.project__sidepaging'), this._dom);
	}

	public setSidePagingItems(container: Element): void {
		var items = [];
		container.querySelectorAll('.sidebartarget').forEach((element: HTMLElement) => {
			items.push({
				targetSelector: `#${element.getAttribute('id')}`,
				label: element.getAttribute('data-sidebar-label')
			});
		});
		this._sidePaging.create(items);
	}

	public selectSidePagingIndex(index: number, theme: UIThemeColourType): void {
		this._sidePaging.selectIndex(index, theme);
	}

	public showSidePaging(): void {
		this._sidePaging.show();
	}

	//DOM structure
	//-------------------------------------------------------------------------------------

	/** Create DOM structure to inject when needed */
	public createDOMStructure(headerType: HeaderType): string {
		return `<section class='project'>

			<a href='#' class='project__center__close '></a>
			<div class='project__ui__bar'>
				<p class='project__ui__bar__label font__smalllabel'>Back to projects</p>
			</div>

			<a href='/spaces/' class='project__close project__close__button ui_hidecursor'></a>
			<a href='/' class='project__home'></a>
			<div class='project__sidepaging'></div>


	      <div class='project__loading'>

	     	<div class='project__loading__bg'></div>
	     	<div class='project__loading__text'></div>
	     	<h1 class='project__intro__title'></h1>
	     	<h2 class='project__intro__subtitle'></h2>

	     	<dl class='project__intro__skills'>


	     	</dl>

	     	<div class='scrolldown-icon'>
	     		<p class='label'>Scroll</p>
	     		<svg width="21px" height="53px" viewBox="0 0 21 53"><style>.style0{fill:#fff;}.style1{stroke:#fff;stroke-width:2.5;stroke-linecap:round;}</style><path d="M9.42307692,0.085483871 C4.14615385,0.683391195 0,5.64602199 0,11.684886 L0,28.426291 C0,34.8537948 4.71153846,40.0854839 10.5,40.0854839 C16.2884615,40.0854839 21,34.8537948 21,28.426291 L21,11.684886 C21,5.64602199 16.8538462,0.683391195 11.5769231,0.085483871 L9.42307692,0.085483871 Z M19,28.6278568 C19,33.8448059 15.1887097,38.0854839 10.5,38.0854839 C5.81129032,38.0854839 2,33.8448059 2,28.6278568 L2,11.543111 C2,6.32616184 5.81129032,2.08548387 10.5,2.08548387 C15.1887097,2.08548387 19,6.32616184 19,11.543111 L19,28.6278568 L19,28.6278568 Z" class="style0"/><path d="M10.5,11.9188172 C11.6045695,11.9188172 12.5,11.0233867 12.5,9.9188172 C12.5,8.8142477 11.6045695,7.9188172 10.5,7.9188172 C9.3954305,7.9188172 8.5,8.8142477 8.5,9.9188172 C8.5,11.0233867 9.3954305,11.9188172 10.5,11.9188172 Z" class="style0"/><g class="arrows"><path d="M10.5,23.7903226 L10.5,30.0200975" class="style1 a1"/><path d="M10.5,34.7903226 L10.5,41.0200975" class="style1 a2"/><path d="M10.5,45.6717982 L10.5,51.9015732" class="style1 a3"/><path d="M6 48 L10.5 52 " class="style1 a3"/><path d="M15,48 L10.5,51.9999994" class="style1 a3"/></g></svg>
	     	</div>


	     </div>



    	 	<div class='project__content'>
			 <div class='project__video__container -${headerType}'>
				 <div class='project__video__overlay'></div>
				 <img class='project__header_image' src='' />
				 <video class='project__video' width="1920" height="1080" preload='auto'  muted loop playsinline>
						<source src='' type='video/mp4' />
					</video>
				</div>
    	 		<div class='project__dynamic__content'></div>
			 </div>


		</section>`;
	}
}
